<template>
  <!-- 轮播模块 -->
  <div class="carousel_wrap">
    <div class="carousel_container">
      <div class="text_box">
        <h1 class="title">{{content.title}}</h1>
        <p class="text">{{content.text}}</p>
        <div
          class="button_box"
          @click="handleJump('/about/intro')"
        >了解更多</div>
      </div>
      <div class="carousel_box">
        <FadeCarousel :items="carouselData"></FadeCarousel>
      </div>
    </div>
  </div>
</template>

<script>
  import FadeCarousel from '@/components/carousel/FadeCarousel.vue'
  export default {
    name: "carousel",
    components: { FadeCarousel },
    props: {
      carouselData: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        content: {
          title: '瑞谦智能，让生活进化',
          text: "瑞谦智能深耕以大数据、人工智能、云计算为新一代信息手段的智慧城市、智慧园区、智慧政务、智慧交通等领域，推动管理手段、管理模式、管理理念，从数字化到智能化再到智慧化发展"
        }
      }
    },
    watch: {
      carouselData() {
        console.log(this.carouselData)
      }
    },
    methods: {
      handleJump(path) {
        console.log(`跳转地址${path}`)
        this.$router.push(path)
      }
    }
  }
</script>

<style scoped lang="scss">
  @keyframes slideUp {
    0% {
      opacity: 0;
      transform: translateY(100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .carousel_wrap {
    //height: 730px;
    width: 100%;
    .carousel_container {
      position: relative;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      .text_box {
        position: absolute;
        top: 55%;
        left: 50%;
        z-index: 999;
        width: 50%;
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        letter-spacing: 3px;
        transform: translate(-50%, -50%);

        @media screen and (max-width: 768px) {
          width: 100%;
          text-align: center;
        }
        .title {
          margin-bottom: 25px;
          font-size: 48px;
          animation: slideUp 2s ease-out forwards;
          @media screen and (max-width: 768px) {
            font-size: 18px;
            margin-bottom: 10px;
            margin-top: 0;
            padding: 0;
          }
        }
        .text {
          padding: 5px 0;
          line-height: 32px;
          font-size: 16px;
          animation: slideUp 2s ease-out forwards;
          @media screen and (max-width: 768px) {
            display: -webkit-box;
            margin: 0 50px;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .button_box {
          width: 150px;
          height: 45px;
          line-height: 45px;
          font-size: 16px;
          text-align: center;
          margin: 40px auto 0;
          border: 1px solid #fff;
          &:hover {
            cursor: pointer;
          }
          @media screen and (max-width: 768px) {
            width: 100px;
            font-size: 14px;
            margin-top: 20px;
          }
          animation: slideUp 2s ease-out forwards;
        }
      }
    }
  }
  .el-carousel__container{
    /*height: 456px;*/
    height: 100% !important;
  }
</style>
